import { render, staticRenderFns } from "./update-role.vue?vue&type=template&id=67010332&scoped=true"
import script from "./update-role.vue?vue&type=script&lang=ts"
export * from "./update-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67010332",
  null
  
)

export default component.exports